/* eslint-disable react/destructuring-assignment, react/prop-types, max-lines, consistent-return */

import {BrowserRouter, Route, Switch} from "react-router-dom";
import {fetchCustomerRequests, updateCustomerRequest} from "../../../actions/index";
import API from "../../../shared/modules/API";
import CartIcon from "../../Cart/CartIcon";
import CartModal from "../../Cart/CartModal";
import EventsAPI from "../../../shared/modules/EventsAPI";
import Helper from "../../../shared/modules/Helper";
import NonMemberCartAPI from "../../../shared/modules/NonMemberCartAPI";
import NonMemberCartModal from "../../NonMember/NonMemberCartModal";
import Notification from "../../../shared/components/Notification";
import NotificationModal from "../../../shared/components/NotificationModal";
import PostPurchaseModal from "../../../shared/components/PostPurchaseModal";
import ProductRouting from "../../Product/components/ProductRouting";
import PropTypes from "prop-types";
import React from "react";
import Wishlist from "../../Wishlist/components/Wishlist";
import {connect} from "react-redux";
import {createPortal} from "react-dom";
import {isMobile} from "../../../lib/userAgent";
import {loadStripe} from "@stripe/stripe-js";
import {withCookies} from "react-cookie";

class GridRouter extends React.Component {
  static propTypes = {
    "analyticsProps": PropTypes.object.isRequired,
    "apiToken": PropTypes.string,
    "comingOffHoldIsBlocked": PropTypes.bool,
    "cookies": PropTypes.object.isRequired,
    "customerHasBillingInfo": PropTypes.bool.isRequired,
    "customerId": PropTypes.string,
    "customerRequests": PropTypes.object.isRequired,
    "eligibleForFineJewelry": PropTypes.bool,
    "enable2024Legal": PropTypes.bool.isRequired,
    "excludeTrendsFromFilter": PropTypes.bool,
    "fetchCustomerRequests": PropTypes.func.isRequired,
    "fetchNewProps": PropTypes.func.isRequired,
    "fromSignup": PropTypes.bool.isRequired,
    "params": PropTypes.object.isRequired,
    "propsCache": PropTypes.object.isRequired,
    "recaptchaSiteKey": PropTypes.string.isRequired,
    "recurlyPublicKey": PropTypes.string.isRequired,
    "renderCouponBanner": PropTypes.bool,
    "stickyFilter": PropTypes.object,
    "stripeEnabled": PropTypes.bool,
    "stripePublicKey": PropTypes.string.isRequired,
    "warehouseClosed": PropTypes.bool,
    "warehouseClosedShopPageText": PropTypes.string
  };

  static defaultProps = {
    "analyticsProps": {},
    "apiToken": null,
    "comingOffHoldIsBlocked": false,
    "customerId": null,
    "customerRequests": {},
    "eligibleForFineJewelry": false,
    "enable2024Legal": false,
    "excludeTrendsFromFilter": false,
    "fromSignup": false,
    "renderCouponBanner": false,
    "stickyFilter":
      {
        "class": "",
        "scrollHeight": 400
      },
    "stripeEnabled": false,
    "stripePromise": null,
    "warehouseClosed": false,
    "warehouseClosedShopPageText": null
  };

  constructor (props) {
    super(props);
    const {apiToken, cookies, customerId} = props;
    API.setApiToken(apiToken);
    API.setCustomerId(customerId);
    API.setAnonymousContactId(cookies.get("anonymous_contact_id"));
    this.state = this.initState(props);
    this.state.lastScrollPosition = $(document).scrollTop();
    this.state.requestsFetched = false;
    this.state.displayCartIcon = true;
    this.state.isCartModalOpen = this.initialCartModalState();
    this.state.displayPurchaseNotification = false;
    this.state.productDetailsModalOpen = false;
    this.state.sessionId = null;
  }

  componentDidMount = () => {
    const {customerId, customerRequests, fetchCustomerRequests, stripePublicKey} = this.props; // eslint-disable-line

    if (stripePublicKey) {
      this.setState({"stripePromise": loadStripe(stripePublicKey)});
    }

    if (!customerId) {
      this.setState({"requestsFetched": true});
    } else if (Object.keys(customerRequests).length === 0) {
      fetchCustomerRequests().then(() => {
        this.setState({"requestsFetched": true});
      });
    }
  }

  // Since parent can update props
  componentDidUpdate = (prevProps) => {
    if (prevProps.propsCache !== this.props.propsCache) {
      this.setState(this.initState(this.props)); // eslint-disable-line
    }
  }

  initialCartModalState = () => {
    const {params} = this.props;

    if (params && params.cart_open && params.cart_open === "true") {
      return true;
    }
    return false;
  }

  addWishListRequest = (prodId, feed) => {
    const {updateCustomerRequest} = this.props; // eslint-disable-line
    API.wishlist(prodId, feed);
    updateCustomerRequest(prodId, "pending");
  }

  fulfillWishListRequest = (prodId) => {
    const {customerRequests, updateCustomerRequest} = this.props; // eslint-disable-line

    if (customerRequests && customerRequests[prodId] && customerRequests[prodId].statuses.includes("pending")) {
      API.wishlist(prodId, false);
      updateCustomerRequest(prodId, "fulfilled");
    }
  }

  removeWishListRequest = (prodId, feed) => {
    const {updateCustomerRequest} = this.props; // eslint-disable-line
    API.unWishlist(prodId, feed);
    updateCustomerRequest(prodId, feed);
  }

  updateLastScrollPosition = (scrollPosition) => {
    this.setState({"lastScrollPosition": scrollPosition});
  }

  initState = (props) => {
    const {products} = props;
    let stateObj = {};
    if (products) {
      stateObj = {
        ...stateObj,
        "products": Helper.createProductObject(products),
        "wishlist": {
          "offset": products.length,
          "productOrdering": products.map(product => product.id)
        }
      };
    }
    return stateObj;
  };

  collectFilters = () => {
    const {selectedFilters} = this.props;
    const filterObj = selectedFilters.
      reduce((res, fil) => {
        const [
          filterType,
          filterName
        ] = fil.key.split(/-(.+)/);
        if (res[filterType]) {
          res[filterType].push(filterName);
        } else {
          res[filterType] = [filterName];
        }
        return res;
      }, {});

    return filterObj;
  }

  checkPageForCartIcon = () => {
    const {pathname} = window.location;
    return pathname.includes("jewelry") || pathname.includes("clearance");
  }

  handleCloseProductDetailsModal = () => {
    this.setState({"productDetailsModalOpen": false});
  }

  handleOpenProductDetailsModal = () => {
    this.setState({"productDetailsModalOpen": true});
  }

  handleCloseCartModal = () => {
    const {sessionId} = this.state;
    if (sessionId) {
      NonMemberCartAPI.expireStripeSession(sessionId);
      this.setState({"sessionId": null});
    }

    if (isMobile()) {
      const elements = document.querySelectorAll(".search-field-container");
      elements.forEach(element => element.classList.remove("hidden"));
    }

    this.setState({"isCartModalOpen": false});
    document.documentElement.classList.remove("no-scroll");
  }

  handleDisplayPurchaseNotification = () => {
    this.setState({"displayPurchaseNotification": true});
  }

  setSessionId = (sessionId) => {
    this.setState({sessionId});
  }

  sendClickedCartIconEvent = () => {
    const {customerId} = this.props;
    const referralUrl = window.location.href;
    const eventName = "clicked_cart_icon";
    const eventDescription = `clicked_from: ${referralUrl}`;

    if (customerId) {
      EventsAPI.trackCustomerEvent(eventName, eventDescription);
    } else {
      const {cookies} = this.props;
      const contactId = cookies.get("anonymous_contact_id");

      EventsAPI.trackContactEvent(
        eventName,
        eventDescription,
        contactId,
      );
    }

    window.analytics.track(eventName, {"clickedFrom": referralUrl});
  }

  handleOpenCartModal = () => {
    this.setState((prevState) => {
      const {isCartModalOpen} = prevState;
      if (!isCartModalOpen) {
        this.sendClickedCartIconEvent();
        document.documentElement.classList.add("no-scroll");
      }
      return {"isCartModalOpen": !isCartModalOpen};
    });
    this.handleCloseProductDetailsModal();
  }

  renderWishlist = (event) => {
    const {
      analyticsProps,
      excludeTrendsFromFilter,
      fetchNewProps,
      filters,
      fromReactivation,
      fromSignup,
      eligibleForFineJewelry,
      nonMemberCartEnabled,
      params,
      propsCache,
      sorts,
      stickyFilter,
      title,
      wishlist
    } = this.props;
    const {lastScrollPosition, products, productDetailsModalOpen, requestsFetched} = this.state;

    return (
      <Wishlist
        addWishListRequest={this.addWishListRequest}
        analyticsProps={analyticsProps}
        collectFilters={this.collectFilters}
        eligibleForFineJewelry={eligibleForFineJewelry}
        event={event}
        excludeTrendsFromFilter={excludeTrendsFromFilter}
        fetchNewProps={fetchNewProps}
        filters={filters}
        fromReactivation={fromReactivation}
        fromSignup={fromSignup}
        handleCloseProductDetailsModal={this.handleCloseProductDetailsModal}
        handleOpenProductDetailsModal={this.handleOpenProductDetailsModal}
        lastScrollPosition={lastScrollPosition}
        modalOpen={productDetailsModalOpen}
        nonMemberCartEnabled={nonMemberCartEnabled}
        params={params}
        products={products}
        propsCache={propsCache}
        removeWishListRequest={this.removeWishListRequest}
        requestsFetched={requestsFetched}
        sorts={sorts}
        stickyFilter={stickyFilter}
        title={title}
        updateLastScrollPosition={this.updateLastScrollPosition}
        updateState={this.updateState}
        {...wishlist}
        {...this.state.wishlist}
      />
    );
  };

  updateState = (state, callback) => this.setState(state, callback);

  showProduct = (event) => {
    const {eligibleForFineJewelry, nonMemberCartEnabled} = this.props;

    return (
      <ProductRouting
        addWishListRequest={this.addWishListRequest}
        eligibleForFineJewelry={eligibleForFineJewelry}
        event={event}
        nonMemberCartEnabled={nonMemberCartEnabled}
        products={this.state.products}
        removeWishListRequest={this.removeWishListRequest}
        requestsFetched={this.state.requestsFetched}
        updateState={this.updateState}
        {...this.props.products}
      />
    );
  }

  findCartIconContainer = () => (
    isMobile()
      ? document.getElementById("cart-icon-container-mobile")
      : document.getElementById("cart-icon-container")
  )

  renderCartModal = () => {
    const {apiToken, enable2024Legal, recaptchaSiteKey, recurlyPublicKey, stripeEnabled} = this.props;
    const {isCartModalOpen, sessionId, stripePromise} = this.state;

    if (isMobile()) {
      document.documentElement.classList.add("no-scroll");
      const elements = document.querySelectorAll(".search-field-container");
      elements.forEach(element => element.classList.add("hidden"));
    }

    if (this.checkPageForCartIcon() && apiToken) {
      return (
        <CartModal
          handleCloseCartModal={this.handleCloseCartModal}
          handleDisplayPurchaseNotification={this.handleDisplayPurchaseNotification}
          isCartModalOpen={isCartModalOpen}
          recurlyPublicKey={recurlyPublicKey}
        />
      );
    }

    if (this.checkPageForCartIcon() && !apiToken) {
      return (
        <NonMemberCartModal
          enable2024Legal={enable2024Legal}
          handleCloseCartModal={this.handleCloseCartModal}
          handleDisplayPurchaseNotification={this.handleDisplayPurchaseNotification}
          isCartModalOpen={isCartModalOpen}
          recaptchaSiteKey={recaptchaSiteKey}
          recurlyPublicKey={recurlyPublicKey}
          sessionId={sessionId}
          setSessionId={this.setSessionId}
          stripeEnabled={stripeEnabled}
          stripePromise={stripePromise}
        />
      );
    }
  }

  renderCartIcon = () => {
    if (this.checkPageForCartIcon()) {
      return (
        <CartIcon handleOpenCartModal={this.handleOpenCartModal} />
      );
    }
  }

  render () {
    const {displayCartIcon, displayPurchaseNotification, isCartModalOpen} = this.state;

    return (
      <React.Fragment>
        <NotificationModal />
        <PostPurchaseModal />
        { displayCartIcon &&
          createPortal(
            this.renderCartIcon(),
            this.findCartIconContainer()
          )
        }
        { isCartModalOpen &&
          this.renderCartModal()
        }
        { displayPurchaseNotification &&
          <Notification
            notificationDisplayText="Order has been successfully placed."
          />
        }
        <BrowserRouter>
          <Switch>
            <Route
              exact
              path="/shop/clearance"
              render={this.renderWishlist}
            />
            <Route
              exact
              path="/jewelry"
              render={this.renderWishlist}
            />
            <Route
              path="/jewelry/:designer/:kind/:name/:id"
              render={this.showProduct}
            />
          </Switch>
        </BrowserRouter>
      </React.Fragment>
    );
  }
}

const mapStoreToProps = store => ({
  "customerRequests": store.customerRequests,
  "selectedFilters": store.selectedFilters || []
});

export default withCookies(connect(
  mapStoreToProps,
  {
    fetchCustomerRequests,
    updateCustomerRequest
  }
)(GridRouter));
